<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/02_Sila/02_1_Acri-Lorica/02_1_Lago-Cecita.jpg">
<div class="content">
    <h1>Sila</h1>
    <h3>Sulle strade della Ciclovia dei Parchi</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale della Sila</a> > <a class="active">Sulle strade della Ciclovia dei Parchi</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Acri-Lago Cecita-Monte Botte Donato-Lorica</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/02_Sila/02_1_Acri-Lorica/02_1_Lago-Cecita.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Il paesaggio silano è contrassegnato dalla presenza di vasti bacini lacustri e questo itinerario ne costeggia due di primaria importanza, 
            il lago Cecita e il lago Arvo, nel cuore della Sila Grande. 
            L’itinerario è suddiviso in due tappe: la prima corrisponde al percorso della Ciclovia dei Parchi che parte da Acri, 
            la città di Sant’Angelo, che apre la strada verso la Sila Greca offrendo panorami splendidi sulle prime radure dell’altopiano silano dove vi sono fattorie e 
            aziende che producono formaggi e patate di qualità eccelsa, come BioSila dove si può soggiornare e degustare piatti tipici della tradizione silana a Km 0. 
            Da qui si procede verso il Lago Cecita, un tracciato che attraversa le campagne di Camigliatello Silano dove si coltivano prodotti agroalimentari di alta qualità,
             dai frutti di bosco, ai formaggi, che si possono degustare presso l’azienda Terre d’Altopiano che affaccia sul lago. 
             Oppure si può scegliere di soggiornare presso San Lorenzo si Alberga che offre la magnifica cucina del ristorante la Tavernetta, che ha anche un’ottima cantina.
            <br>
            <br>
            Dal Cecita, dove non si può mancare di dedicare del tempo al Centro visita di Cupone per conoscere da vicino il patrimonio di biodiversità della Sila, 
            si riparte in direzione di Croce di Magara, dove si toccano i 1400 m di altitudine, e da qui procedere verso la Riserva di Fallistro, tutelata dal FAI, 
            dove godere delle meraviglie dei cosiddetti “Giganti della Sila”.
             Visitato il Parco si procede in direzione sud verso la magnifica Strada delle Vette verso Monte Botte Donato che si raggiunge dopo aver valicato il Monte Sorbello 
             (1856 m) e il Monte Coppo (1876 m) attraversando paesaggi montani con ampie vallate e fitte faggete. 
             Giunti in cima si gode un panorama immenso fino all’estremo sud della Calabria. Monte Botte Donato (1928 m) è la cima più alta del Parco della Sila ed è 
             collegata a Lorica da un impianto di risalita utilizzato d’inverno pe raggiungere le piste da sci. Tornati sulla Strada delle Vette si percorre la lunga e 
             piacevole discesa che porta al centro di Lorica in poco più di 15 Km. 
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>difficile</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>71,5 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>1850 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1180 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Acri</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Lorica (San Giovanni in Fiore)</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-9 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale della Sila.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img src="../../../assets/images/03_Parchi-Riserve/logo-parco-sila.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToAcri()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gli storici villaggi<br />della Sila</h1>
                        <a (click)="goToLorica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Arte e spiritualità<br />in Sila</h1>
                        <a (click)="goToArte()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
